import deepGet from "lodash/get"
import https from "./https";
import store from "@/store";

const bookingPresetApi = {
  async get(id, params = {}) {
    const organization = store.state.liffGeneral.orgCode;

    let { data } = await https.get(
      `${organization}/liff/booking-presets/${id}`, {
        params
      }
    );

    return data.data;
  },
  async getOccupancy(id, params = {}) {
    return deepGet(
      await https.get(`${store.state.liffGeneral.orgCode}/liff/booking-presets/${id}/get-occupancy`, { params }),
      'data.data',
      []
    );
  },
  async checkAvailability(id, params = {}) {
    return deepGet(
      await https.get(`${store.state.liffGeneral.orgCode}/liff/booking-presets/${id}/check-availability`, { params }),
      'data.data',
      []
    );
  },
  async getStaffs(id, params = {}) {
    const organization = store.state.liffGeneral.orgCode;
    let { data } = await https.get(
      `${organization}/liff/booking-presets/${id}/staffs`, {
        params
      }
    );
    return data.data;
  },
};

export default bookingPresetApi;
